// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_9f-0";
export var optionCard = "_9f-1";